import { render } from "./collapsible-question.vue?vue&type=template&id=49a6a13c&scoped=true&ts=true"
import script from "./collapsible-question.vue?vue&type=script&lang=ts"
export * from "./collapsible-question.vue?vue&type=script&lang=ts"

import "./collapsible-question.vue?vue&type=style&index=0&id=49a6a13c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a6a13c"]])

export default __exports__